import { Edit, Eye, History, Trash } from "lucide-react";
import React from "react";
import { Table, Button, Popover, OverlayTrigger } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const UserList = ({ user, onEdit, onDelete, onView, deletingId }) => {

  const navigate = useNavigate()

  const handleSubscriptionHistory = (userId) => {
    navigate(`/admin/subscripersHistory/${userId}`);
  }

  const viewPopover = (
    <Popover id="popover-view">
      <Popover.Body>View User details</Popover.Body>
    </Popover>
  );
  const editPopover = (
    <Popover id="popover-view">
      <Popover.Body>Edit User details</Popover.Body>
    </Popover>
  );
  const deletePopover = (
    <Popover id="popover-view">
      <Popover.Body>Delete User </Popover.Body>
    </Popover>
  );
  const subscriptionPopover = (
    <Popover id="popover-view">
      <Popover.Body>Subscription History </Popover.Body>
    </Popover>
  );
  return (
    <Table className="custom-employee-table" bordered hover responsive>
      <thead>
        <tr>
          <th>S.No</th>
          <th>UserName</th>
          <th>Email</th>
          <th>Plan</th>
          <th>Expiry Date</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {user.length > 0 ? (
          user.map((usr, idx) => (
            <tr key={usr.userId}>
              <td>{idx + 1}</td>
              <td>{usr.username}</td>
              <td>{usr.email}</td>
              <td>{usr.plan || "Not Yet"}</td>
              <td>{usr.expiryDate || "0000-00-00"}</td>

              <td>
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={viewPopover}
                >
                  <Button
                    size="sm"
                    className="me-1"
                    style={{
                      backgroundColor: "#10296C",
                      padding: "5px",
                      borderRadius: "5px",
                      marginRight: "5px",
                    }}
                    onClick={() => onView(usr)}
                  >
                    <Eye />
                  </Button>
                </OverlayTrigger>

                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={editPopover}
                >
                  <Button
                    size="sm"
                    variant="warning"
                    className="me-1"
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                      marginRight: "5px",
                    }}
                    onClick={() => onEdit(usr)}
                  >
                    <Edit />
                  </Button>
                </OverlayTrigger>
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={subscriptionPopover}
                >
                  <Button
                    size="sm"
                    variant="warning"
                    className="me-1"
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                      marginRight: "5px",
                    }}
                    onClick={() => handleSubscriptionHistory(usr.userId)}
                  >
                    <History />
                  </Button>
                </OverlayTrigger>
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={deletePopover}
                >
                  <Button
                    size="sm"
                    variant="danger"
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                      marginRight: "5px",
                    }}
                    onClick={() => onDelete(usr.userId)}
                    disabled={usr.userId === deletingId}
                  >
                    {usr.userId === deletingId ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Deleting...
                      </>
                    ) : (
                      <Trash />
                    )}
                  </Button>
                </OverlayTrigger>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="6" className="text-center">
              Not found.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default UserList;
